<template>
    <div class="package">
        <div class="box-white-wrapper" v-if="inventory.createdAt != undefined">
            
            <div class="wrap-actions">
                <span @click="modalActive = !modalActive" class="editInv">Editar Inventario</span>
                <a href="/inventory/add" class="viewBill">Nuevo Registro</a>
            </div>

            <div class="wrap-box"  id="print" style="margin-top:20px">
            
                <div class="item">
                        <div class="head">
                            <div class="icon">
                                <img src="@/assets/images/package.png" alt="" class="img-fluid">
                            </div>
                            <div class="subTitle">Información del paquete</div>
                        </div>
                        <div class="detail">
                            <h3>Fecha registro:</h3>
                            <p>{{ inventory.createdAt | moment('DD/MM/YYYY') }}</p>
                        </div>
                        <div class="detail">
                            <h3>Nro Tracking:</h3>
                            <p>{{ inventory.tracking }}</p>
                        </div>
                        <div class="detail">
                            <h3>Producto:</h3>
                            <p>{{inventory.product.name}}</p>
                        </div>
                        <div class="detail">
                            <h3>Peso:</h3>
                            <p>{{ inventory.weight }} lbs</p>
                        </div>
                        <div class="detail address">
                            <h3>Observaciones</h3>
                            <p>{{ inventory.comments }}</p>
                        </div>
                        <div class="detassil addresss" id="barcode" style="text-align: right">
                            <barcode v-bind:value="inventory.id" :height='65' :width="6">
                                Show this if the rendering fails.
                            </barcode>
                        </div>
                        <vs-button id="btnFilter" class="vs-con-loading__container" 
                            color="primary" type="border" 
                            style="width: 100%; margin: 30px auto;"
                            icon="print" @click="print()">Imprimir</vs-button>
       
                </div>

                <div class="item">
                        <div class="head">
                            <div class="icon">
                                <vs-avatar :src="inventory.customer.profileUrl" size="70px"/>
                            </div>
                            <div class="subTitle">Información del cliente</div>
                        </div>
                        <div class="detail">
                            <h3>Nombre</h3>
                            <p><router-link :to="`/customers/${inventory.customer.id}`">{{ inventory.customer.firstName + " " + inventory.customer.lastName}}</router-link></p>
                        </div>
                        <div class="detail">
                            <h3>Cédula o pasaporte:</h3>
                            <p>{{ inventory.customer.identification }}</p>
                        </div>
                        <div class="detail">
                            <h3>Email:</h3>
                            <p>{{ inventory.customer.email }}</p>
                        </div>
                        <div class="detail">
                            <h3>Teléfono:</h3>
                            <p>{{ inventory.customer.mobile +' / '+ inventory.customer.phone}}</p>
                        </div>
                </div>
            </div>
        </div>     

         <modal-inventory @modal-event="handleActionModalInv" :inv="inventory" :show="modalActive"></modal-inventory>
       

    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import VueBarcode from 'vue-barcode';
import InventoryService from "@/services/InventoryService"

import ModalInventory from '@/components/Modal/InventoryModal.vue'

export default {
  name: "Package",
  mixins: [helper],
  components: {'barcode': VueBarcode, ModalInventory},
  data () {
    return {
      inventory: {},
      modalActive: false,

    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  created(){
    this.Roles = Role
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.retrievePackage(this.$route.params.id)
  },
  methods: {
    handleActionModalInv(response) {
        if(response.error !=  undefined){
        if(!response.error){
          this.$vs.notify({title:'Información!',text:'El inventario fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el inventario',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active
    },
    retrievePackage(id) {
        InventoryService.getInventoryDetail(id)
        .then(response => {
            this.inventory = response.data.obj;
            this.$Progress.finish()
        })
        .catch(e => {
            console.log(e)
            if(e.response.status == 404){
              this.$router.push({ name: "packages"})
              this.$vs.notify({title:'Error!',text:'El paquete no fue encontrado.',color:'danger',icon:'error_outline'})
            }else{
              this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del paquete!',color:'danger',icon:'error_outline'})
            }
        });
    },   
    print() {
        // Get HTML to print from element
        const barcode = document.getElementById('barcode').innerHTML;
        const WinPrint = window.open('', '', 'left=0,top=0,width=540,height=600,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head></head>
        <body>
            <table style="width: 640px">
                <tr>
                    <td colspan="2" style="text-align: left;padding: 10px; padding-bottom:25px"><img src='`+ require('../../assets/images/logo.png')+`'/></td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: #223350;padding-bottom: 10px;font-size: 31px;">Code:</td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 10px;font-size: 28px;">SJO 375592</td>
                </tr>
                <tr>
                    <td colspan="2" heigth="15"></td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: #223350;width: 135px;padding-bottom: 10px;font-size: 31px;">Consignee:</td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 10px;font-size: 28px;">`+ this.inventory.customer.firstName + " " + this.inventory.customer.lastName + `</td>
                </tr>
                <tr>
                    <td colspan="2" heigth="15"></td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: #223350;width: 135px;padding-bottom: 10px;font-size: 31px;">Description:</td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 10px;font-size: 28px;">`+ this.inventory.product.name + `</td>
                </tr>
                <tr>
                    <td colspan="2" colspan="2" heigth="15"></td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: #223350;width: 135px;padding-bottom: 10px;font-size: 31px;">Location:</td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 10px;font-size: 28px;">`+ this.inventory.inv02Code + `</td>
                </tr>
                <tr>
                    <td colspan="2" heigth="15"></td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: #223350;width: 135px;padding-bottom: 15px;font-size: 31px;">Weight:</td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 15px;font-size: 28px;">`+ this.inventory.weight + `Lb</td>
                </tr>
                <tr>
                    <td colspan="2" heigth="15"></td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-top: 10px;margin-left: 10px">` + barcode +`</td>
                </tr>
            </table>
        </body>
        </html>`);


        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        // WinPrint.close();
    } 
    
  }
}
</script>